const THIRD_PARTY_CLAIM_TRACKERS = ["VAVE", "MRKL"];

export default THIRD_PARTY_CLAIM_TRACKERS;
